import { PencilIcon, TrashIcon, EyeIcon } from "@heroicons/react/24/outline";
import { IconButton } from "../../../../../../../components/ui";

const Actions = props => {
  const { id } = props || {};

  if (typeof id == "number") {
    return (
      <div className="user-list-actions flex text-right text-sm font-medium">
        {id && (
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
            <IconButton variant="clean" title="Edit Shipment">
              <PencilIcon
                className={`h-4 w-4 cursor-pointer text-gray-400`}
                onClick={() => {}}
              />
            </IconButton>
            <IconButton variant="clean" title="View Shipment">
              <EyeIcon
                className={`h-4 w-4 cursor-pointer text-gray-400`}
                onClick={() => {}}
              />
            </IconButton>
            <IconButton variant="clean" title="Delete Shipment">
              <TrashIcon
                className={`h-4 w-4 cursor-pointer text-gray-400`}
                onClick={() => {}}
              />
            </IconButton>
          </div>
        )}
      </div>
    );
  } else {
    return false;
  }
};

export default Actions;
